import { LOCALES, LOCALIZED_DIFF } from "../constants";
import { loadData } from "./dataLoader";

let buffs;

loadData("buffs.json").then((data) => (buffs = data));

const colorTagRegex = new RegExp("<color=#(?<color>[0-9A-F]{6})>", "gm");
const bColorTagRegex = new RegExp("<b><color=#(?<color>[0-9A-F]{6})>", "gm");

const replaceColorTag = (string) => {
    let result = bColorTagRegex.exec(string);
    if (!result) return string;

    while (result) {
        string = string.replaceAll(bColorTagRegex, `<b style="color: #${result.groups.color};">`);
        result = bColorTagRegex.exec(string);
    }

    return string.replaceAll("</color>", "").replaceAll(/\n/g, "<br />");
};

const changeColorTagToSpan = (string) => {
    let result = colorTagRegex.exec(string);
    if (!result) return string;

    while (result) {
        string = string.replaceAll(colorTagRegex, `<span style="color: #${result.groups.color};">`);
        result = colorTagRegex.exec(string);
    }

    return string.replaceAll("</color>", "</span>");
};

const toUnicodeRegexpString = (str) => {
    return str.replaceAll("(", "\\(").replaceAll(")", "\\)").replaceAll("-", "\\-");
};

const getSkillDescWithFlavorTexts = (lang, desc) => {
    const buffList = [];

    buffs.forEach((buff) => {
        if (desc[lang].includes(buff.name[lang]) && !buffList.find((e) => e.name[lang] === buff.name[lang])) {
            const regex = new RegExp(`<b><color=#(?<color>[0-9a-fA-F]{6})>${toUnicodeRegexpString(buff.name[lang])}`, "g");
            if (regex.test(desc[lang])) {
                buffList.push(buff);
            }
        }
    });

    return {
        desc: replaceColorTag(desc[lang]),
        buffList: buffList,
    };
};

const FACTOR_TITLE = {
    dmg_factor: { "ko-KR": "대미지 계수", "en-US": "Damage Multiplier" },
    heal_factor: { "ko-KR": "회복 계수", "en-US": "Heal Multiplier" },
    barrier_factor: { "ko-KR": "보호막 계수", "en-US": "Barrier Multiplier" },
};
const FACTOR_TEXT = {
    atk_factor: { "ko-KR": "공격력 계수", "en-US": "Atk Multiplier" },
    hp_factor: { "ko-KR": "생명력 계수", "en-US": "Hp Multiplier" },
    def_factor: { "ko-KR": "방어력 계수", "en-US": "Def Multiplier" },
    spd_factor: { "ko-KR": "속도 계수", "en-US": "Spd Multiplier" },
};
const getFactorTag = (lang, skill) => {
    const texts = [];
    if (Object.values(skill.factors.damage_factor).reduce((p, c) => p + c) > 0) {
        texts.push(FACTOR_TITLE.dmg_factor[lang]);
        Object.keys(skill.factors.damage_factor).forEach((factor_eng) => {
            if (skill.factors.damage_factor[factor_eng] !== 0) {
                texts.push(`&nbsp;&nbsp;${FACTOR_TEXT[factor_eng][lang]} - ${skill.factors.damage_factor[factor_eng] / 10_000}`);
            }
        });
    }

    const passiveSeList = skill.type === 0 ? [...skill.levels[0].se_list, ...skill.levels[1].se_list] : skill.levels[0].se_list;
    if (
        Object.values(skill.factors.heal_factor).reduce((p, c) => p + c) > 0 ||
        passiveSeList.find((e) => e.healRate !== null) !== undefined
    ) {
        texts.push(FACTOR_TITLE.heal_factor[lang]);
        Object.keys(skill.factors.heal_factor).forEach((factor_eng) => {
            const stat = factor_eng.replace("_factor", "");
            const healSe = passiveSeList.find((e) => e.healStatType === stat && e.healRate !== null);

            if (skill.factors.heal_factor[factor_eng] !== 0 || (healSe !== undefined && healSe.healRate !== null)) {
                texts.push(
                    `&nbsp;&nbsp;${FACTOR_TEXT[factor_eng][lang]} - ${(skill.factors.heal_factor[factor_eng] + (healSe ? healSe.healRate : 0)) / 10_000}`,
                );
            }
        });
    }

    if (passiveSeList.find((e) => e.barrierRate !== null) !== undefined) {
        texts.push(FACTOR_TITLE.barrier_factor[lang]);
        const barrierSe = passiveSeList.find((e) => e.barrierRate !== null);
        if (barrierSe) {
            texts.push(`&nbsp;&nbsp;${FACTOR_TEXT[`${barrierSe.barrierStatType}_factor`][lang]} - ${barrierSe.barrierRate / 10_000}`);
        }
    }

    return texts.join("<br />");
};

// 잠재력 레벨의 se_list 안 addDamageStatType/addDamageRate(추가 피해 계수)를 스킬 계수와 같은 형식으로 표시.
const getPotentialFactorTag = (lang, potentialLevel) => {
    if (!potentialLevel || !potentialLevel.se_list) return "";

    const se = potentialLevel.se_list.find((e) => e.addDamageStatType);
    if (!se) return "";

    return `${FACTOR_TITLE.dmg_factor[lang]}<br />&nbsp;&nbsp;${FACTOR_TEXT[`${se.addDamageStatType}_factor`][lang]} - ${se.addDamageRate / 10_000}`;
};

const NOVA_FACTOR_TITLE = {
    dmg_factor: { "ko-KR": "대미지 증가", "en-US": "Damage Up" },
    heal_factor: { "ko-KR": "회복량 증가(스킬 레벨 효과와 합연산 후 본래 회복량에 곱연산)", "en-US": "Heal Up" },
    barrier_factor: { "ko-KR": "보호막 계수", "en-US": "Barrier Multiplier" },
};
const getNovaBuffTag = (lang, skill) => {
    const texts = [];

    const damageBuffs = skill.nova_se_list.filter((se) => se.buff_str_id === "BI_STAT_NST_RATE_DAMAGE_UP");
    if (damageBuffs.length > 0) {
        texts.push(NOVA_FACTOR_TITLE.dmg_factor[lang]);
        damageBuffs.forEach((se) => {
            texts.push(`&nbsp;&nbsp;+${se.buff_value / 100}%`);
        });
    }

    const healBuffs = skill.nova_se_list.filter((se) => se.buff_str_id === "BI_STAT_NST_RATE_HEAL_GIVE");
    if (healBuffs.length > 0) {
        texts.push(NOVA_FACTOR_TITLE.heal_factor[lang]);
        healBuffs.forEach((se) => {
            texts.push(`&nbsp;&nbsp;+${se.buff_value / 100}%`);
        });
    }

    const barrierBuffs = skill.nova_se_list.filter((se) => se.buff_str_id === "BI_BARRIER");
    if (barrierBuffs.length > 0) {
        texts.push(NOVA_FACTOR_TITLE.barrier_factor[lang]);
        barrierBuffs.forEach((se) => {
            texts.push(`&nbsp;&nbsp;${FACTOR_TEXT[`${se.barrierStatType}_factor`][lang]} - ${se.barrierRate / 10_000}`);
        });
    }

    return texts.join("<br />");
};

const getJourneyTimeString = (lang, time) => {
    if (lang === LOCALES.KO) return time;
    if (time === "시작") return "Start";
    if (time === "평가전") return "Trial";

    const [m, d] = time.split(" ").map((e) => e.replace(/[월]/, ""));
    if (d === "초순") return `Early ${m}`;
    else if (d === "중순") return `Mid ${m}`;
    else if (d === "하순") return `Late ${m}`;
};

const getLocalizedDiffText = (target, lang) => {
    if (lang === LOCALES.KO) return target;

    return target
        .replace("쉬움", LOCALIZED_DIFF["쉬움"][lang])
        .replace("보통", LOCALIZED_DIFF["보통"][lang])
        .replace("어려움", LOCALIZED_DIFF["어려움"][lang]);
};

export {
    replaceColorTag,
    changeColorTagToSpan,
    getSkillDescWithFlavorTexts,
    getFactorTag,
    getPotentialFactorTag,
    getNovaBuffTag,
    getJourneyTimeString,
    getLocalizedDiffText,
};
